var Container = require('./container');

module.exports = Container.extend({
    icon: 'icon-box', //icm-drawer
    desc: 'File Cabinet'
});




/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewer/models/container/fileCabinet.js
 ** module id = 394
 ** module chunks = 0
 **/